<template>
  <div class="order__items">
    <template  v-for="(item, index) in selectedItems">
      <div class="order__item" v-bind:key="item.id">
        <b-form-checkbox
          @click.native.stop
          v-model="item.selected"
          @change="updateItem($event, index)"
          class="check ml-1"
        >
        </b-form-checkbox>
        <div class="order__item__image">
          <img :src="getItemImageUrl(item)" @error="setAltImg($event, item)" alt="" />
        </div>
        <div class="order__item__info">
          <p class="order__item__info__name ellipses" v-html="item.name"></p>
          <span class="order__item__info__text">
            <template v-if="isRecurring(item)">
              <span>Subscription</span>
            </template>
            <span v-else>One-time Order</span>
          </span>
          <span class="order__item__info__text">
            Quantity: <span class="ml-1">{{item.quantity}}</span>
          </span>
          <span class="order__item__info__text item__price">
            {{item.price | currency(currency)}}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {getItemImageUrl, isRecurring, setFallbackImageUrl} from '@/utils'

export default {
  name: 'SelectOrderItem',
  props: {
    items: Array,
    currency: String,
    isCancelOrReturnOrder: Boolean
  },
  data: function() {
    return {
      selectedItems: []
    }
  },
  methods: {
    getItemImageUrl: function(item) {
      return getItemImageUrl(item, 'large')
    },
    isRecurring: function(item) {
      return isRecurring(item)
    },
    setAltImg: function(event, item) {
      setFallbackImageUrl(event, item, 'large', true)
    },
    updateItem: function(event, index) {
      this.selectedItems[index].selected = event
      this.$emit('updateItems', this.selectedItems.filter((item) => item.selected))
    }
  },
  mounted() {
    if (this.items && this.items.length) {
      this.selectedItems = this.items.map((item) => {
        item.selected = !this.isCancelOrReturnOrder
        return item
      })
      this.$emit('updateItems', this.selectedItems)
    }
  }
}
</script>

<style scoped>

</style>
